export default {
  init() {
    // JavaScript to be fired on all pages
    function resizeFullWidthRow() {
      $('[data-vc-full-width="true"]').each(function () {
        $(this).css({
          width: document.body.clientWidth,
          marginLeft: -document.body.clientWidth / 2,
        })
        if (!$(this).attr('data-vc-stretch-content')) {
          let padding =
            (document.body.clientWidth - $('.container.wrap').outerWidth()) / 2
          $(this).css({
            'padding-left': padding,
            'padding-right': padding,
          })
        }
      })
    }

    function connectHeroAndFooter() {
      if ($('.page-template-default')[0]) {
        const content = $('.wrap.container[role="document"]')
        const contentHeight = content.outerHeight()
        const hero = $('.internal_banner')

        if (contentHeight < 700) {
          const docHeight = $(document).height()
          const heroHeight = hero.outerHeight()
          const footerHeight = $('.footer').outerHeight()
          let spaceHeight = docHeight - heroHeight - footerHeight
          const contentMargin = parseInt(content.css('marginTop'))
          hero.height('')
          content.css('marginTop', '')

          hero.height(heroHeight + spaceHeight)
          content.css('marginTop', contentMargin - spaceHeight)
        }
      }
    }

    function highlightLink() {
      let hash = window.location.hash
      if (hash) {
        $(
          '.banner .header .main-menu .navbar-nav .first_lvl ~ .dropdown-menu .dropdown-item[href$=' +
            hash +
            ']'
        ).addClass('active')
      }
    }

    $('.dropdown-menu .menu-item-type-custom > .nav-link').on(
      'click',
      function () {
        $(
          '.banner .header .main-menu .navbar-nav .first_lvl ~ .dropdown-menu .dropdown-item'
        ).removeClass('active')
        $(this).addClass('active')
      }
    )

    $(document).on('ready', function () {
      $('.nav-item.disabled > a').on('click', function (e) {
        e.preventDefault()
      })
      connectHeroAndFooter()
      highlightLink()
    })

    resizeFullWidthRow()

    function setMenuLeft() {
      if ($('.device-lg, .device-xl').is(':visible')) {
        $('.first_lvl').each(function () {
          let paddingLeft = parseInt($(this).parent().css('padding-left'))
          let left = $(this).parent().position().left
          $(this)
            .siblings('.dropdown-menu')
            .css({ paddingLeft: left + paddingLeft })
        })
      } else {
        $('.first_lvl').siblings('.dropdown-menu').css({ paddingLeft: '' })
      }
    }

    $(window).on('resize', function () {
      connectHeroAndFooter()
      resizeFullWidthRow()
      setMenuLeft()
    })

    //smooth_scroll
    function smooth_scroll(link, e) {
      if (e) {
        e.preventDefault()
        if (e.isTrigger) {
          return false
        }
      }
      var hash = false
      if (!link && window.location.hash) {
        hash = window.location.hash
      } else if (link && link.indexOf('#') == 0) {
        hash = link
      } else if (
        link &&
        location.pathname.replace(/^\//, '') ==
          link.pathname.replace(/^\//, '') &&
        location.hostname == link.hostname
      ) {
        hash = link.hash
      }
      if (hash) {
        $('html, body').animate(
          {
            scrollTop: $(hash).offset().top - $('header.banner').outerHeight(),
          },
          600
        )
        if ($(window).scrollTop() == 0) {
          setTimeout(function () {
            $('html, body').animate(
              {
                scrollTop:
                  $(hash).offset().top - $('header.banner').outerHeight(),
              },
              600
            )
          }, 500)
        }
        history.replaceState(null, null, hash)
      }
    }

    $(document).on(
      'click',
      'a[href^="#"]:not([href="#"],[href="#0"],[href^="#fancy-"],[data-vc-tabs],[role="tab"])',
      function (e) {
        smooth_scroll($(this).attr('href'), e)
      }
    )
    if (window.location.hash) {
      smooth_scroll(window.location.hash)
    }

    // fade-in effect on page load
    setTimeout(function () {
      $('body').removeClass('fade-out')
    }, 1)

    //transform menu burger on click
    $('.navbar-toggler__icon').on('click', function () {
      $(this).toggleClass('open').closest('.header').toggleClass('open')
    })

    //Toggle header Search

    $(document).on('click', function (e) {
      if (
        e.target.parentElement.className === 'search-button js-search-button'
      ) {
        $('.search_open').toggleClass('opened')
        $('.banner .searchform-wrapper').slideToggle()

        if ($('.navbar-toggler__icon').hasClass('open')) {
          $('.navbar-toggler__icon').removeClass('open')
          $('.main-menu.navbar-collapse').removeClass('show').css('')
        }
      } else if (e.target.name !== 's') {
        $('.search_open').removeClass('opened')
        $('.banner .searchform-wrapper').slideUp()
      }

      if ($('.search_open').hasClass('opened')) {
        $('.banner .searchform-wrapper .search-field').focus()
      }
    })

    //Scroll to Top button
    $(window).scroll(function () {
      if ($(this).scrollTop() > 500) {
        $('.scrollToTop').fadeIn()
      } else {
        $('.scrollToTop').fadeOut()
      }
    })

    $('.scrollToTop').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 1000)
      return false
    })

    //hide border for Captcha and Textarea

    if ($('.ginput_recaptcha, .ginput_container_textarea').length) {
      $('.ginput_recaptcha, .ginput_container_textarea')
        .closest('.gfield')
        .addClass('no_border')
    }

    //Toggle dropdown menu
    $('.first_lvl').on('click', function (e) {
      e.preventDefault()
      let paddingLeft = parseInt($(this).parent().css('padding-left'))
      let left = $(this).parent().position().left
      if ($('.device-lg, .device-xl').is(':visible')) {
        $(this)
          .siblings('.dropdown-menu')
          .css({ paddingLeft: left + paddingLeft })
      } else {
        $(this).siblings('.dropdown-menu').css('padding-left', '')
      }
      if (!$(this).find('.dropdown-toggle').hasClass('opened')) {
        $('.first_lvl > .dropdown-toggle')
          .removeClass('opened')
          .closest('.first_lvl')
          .siblings('.dropdown-menu')
          .slideUp('medium')
          .closest('.menu-item')
          .removeClass('active')
        $(this)
          .find('.dropdown-toggle')
          .addClass('opened')
          .closest('.first_lvl')
          .siblings('.dropdown-menu')
          .slideDown('medium', function () {
            if ($(this).is(':visible')) {
              $(this).css('display', 'flex')
            }
          })
          .closest('.menu-item')
          .addClass('active')
      } else {
        $(this)
          .find('.dropdown-toggle')
          .removeClass('opened')
          .closest('.first_lvl')
          .siblings('.dropdown-menu')
          .slideUp('medium')
          .closest('.menu-item')
          .removeClass('active')
      }
    })

    $('.dflex > .dropdown-menu').css('display', 'none')
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
}

function init_gfMultifileUpload() {
  //GForms upload button rebuild

  $('.ginput_container_fileupload').each(function () {
    const buttonText = $(this).siblings('.gfield_label').text()
    $(this).find('.gform_button_select_files').val(buttonText)
  })
}

jQuery(document).on('gform_post_render', function () {
  init_gfMultifileUpload()
})
